import {
	type ComponentChildren,
	createContext,
	type FunctionComponent,
} from "preact";
import { useContext } from "preact/hooks";

import type { ApiClient } from "./api-client.js";

const context = createContext<ApiClient | null>(null);

export type ApiClientProviderProps = {
	client: ApiClient;
	children: ComponentChildren;
};

export const ApiClientProvider: FunctionComponent<ApiClientProviderProps> = ({
	client,
	children,
}) => <context.Provider value={client}>{children}</context.Provider>;

export const useApiClient = (): ApiClient => {
	const client = useContext(context);
	if (!client) {
		throw new Error(`Missing required ${ApiClientProvider.name}`);
	}
	return client;
};
